import { Component, OnInit, ViewChild } from '@angular/core';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { ErroresBaseDatosService } from '../../servicios/errores-base-datos.service';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { ConmaetipgastoService } from '../conservicios/conmaetipgasto.service';
import { Conmaetipgasto } from '../coninterfaces/conmaetipgas';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { AggridBanComponent } from 'src/app/ban/aggrid-ban/aggrid-ban.component';
import { AggridsaciComponent } from 'src/app/advantage/aggridsaci/aggridsaci.component';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-conmaetipgasto',
  templateUrl: './conmaetipgasto.component.html',
  styleUrls: ['../../advantage/styles/saciwebmae.css']
})
export class ConmaetipgastoComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  defaultColDefconmaetipgasto;
  public frameworkComponents;
  rowStyle;
  largo = '258';
  rowSelection = 'multiple';
  conmaetipgasto: Conmaetipgasto[] = [];
  selectedconmaetipgasto: Conmaetipgasto;
  tipgasseleccionada: Conmaetipgasto = {}
  btnNuevo: boolean;
  btnBorrar: boolean;
  btnRegresar: boolean;
  btnGuardar: boolean;
  btnPrimero: boolean;
  btnAnterior: boolean;
  btnSiguiente: boolean;
  btnUltimo: boolean;
  inputNum: boolean;
  indice: number;
  opcion: string;
  codigoAux: any;
  permisoTipGasto: SegMaePermiso;
  columnDefConMaeTipgasto = [
    {
      headerName: 'Código.', field: 'TIPGAS_CODIGO', cellEditor: 'cellPrueba', width: 100, editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 35,
          tienecalculos: false,
        }
      }
    },
    {
      headerName: 'Nombre', field: 'TIPGAS_NOMBRE', cellEditor: 'cellPrueba', width: 350, editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 45,
          tienecalculos: false,
        }
      }
    },


  ]
  constructor(private tipgastoService: ConmaetipgastoService, private message: MessageService,
    private errorService: ErroresBaseDatosService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService, private permisosService: PermisosService,
    private auditoriagral: AuditoriagralService, private confInciales: ConfInicialesService,
    private busqService: InvbusquedaService, private init: NuevoComponentService,
    private busquedaSer: InvbusquedaService) {
    this.agTable()
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.defaultColDefconmaetipgasto = {
      editable: true,
      width: 130,
      objeto: 'maeTipGasto'
    };
  }
  async ngOnInit() {
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    this.btnPrimero = false;
    this.btnAnterior = false;
    this.btnSiguiente = false;
    this.btnUltimo = false;
    this.indice = 0;
    this.inputNum = true;
    const data = await this.tipgastoService.getTipogasto()
    if (data !== null) {
      if (data.length > 0) {
        for (const iterator of data) {
          iterator.NUEVOL = false
        }
        this.conmaetipgasto = data
      }
    }
    this.permisosService.getListaPermisos('CON', '1', '1061').subscribe((permiso) => {
      this.permisoTipGasto = permiso[0];
    });

  }
  async manejarSenales(valor) {
    if (valor === 'Nuevo') {
      if (this.permisoTipGasto.PERINSERCION === 1) {
        this.btnNuevo = true;
        this.btnGuardar = false;
        this.btnBorrar = false;
        this.btnRegresar = false;
        this.btnPrimero = true;
        this.btnSiguiente = true;
        this.btnAnterior = true;
        this.btnUltimo = true;
        this.tipgasseleccionada = {
          TIPGAS_CODIGO: '',
          TIPGAS_NOMBRE: '',
          COM_CODIGO: '01',
          NUEVOL: true
        }
        this.conmaetipgasto.push(this.tipgasseleccionada)
        this.selectedconmaetipgasto = this.tipgasseleccionada
        this.aggrid.refreshaggrid(this.conmaetipgasto, this.defaultColDefconmaetipgasto.objeto);
      } else if (this.permisoTipGasto.PERINSERCION === 0) {
        this.message.add({
          key: 'contipogasto',
          severity: 'error',
          summary: 'Inserción de Tipo de Gasto',
          detail: 'El usuario no tiene permisos de inserción, acción denegada'
        });
      }
    }
    if (valor === 'Cancelar') {
      this.btnNuevo = false;
      this.btnGuardar = true;
      this.btnBorrar = false;
      this.btnRegresar = true;
      this.btnPrimero = false;
      this.btnAnterior = false;
      this.btnSiguiente = false;
      this.btnUltimo = false;
      try {
        this.conmaetipgasto = []
        const data = await this.tipgastoService.getTipogasto()
        if (data !== null) {
          if (data.length > 0) {
            for (const iterator of data) {
              iterator.NUEVOL = false
            }
            this.conmaetipgasto = data
            this.aggrid.refreshaggrid(this.conmaetipgasto, this.defaultColDefconmaetipgasto.objeto);
          }
        }
      } catch (error) {
        this.message.add({
          key: 'contipogasto',
          severity: 'error',
          summary: 'Consultar tipo de gasto',
          detail: 'Ocurrió un error al consultar el tipo de gasto ' + error
        });
      }

    }
    if (valor === 'Guardar') {
      if (this.permisoTipGasto.PERACTUALIZACION === 1) {
        if (isNullOrUndefined(this.selectedconmaetipgasto.TIPGAS_CODIGO) || this.selectedconmaetipgasto.TIPGAS_CODIGO === '') {
          this.message.add({
            key: 'contipogasto',
            severity: 'error',
            summary: 'Validación de Tipos de Gasto ',
            detail: 'El código del tipo de gasto no puede estar vacío'
          });
          return
        }
        if (isNullOrUndefined(this.selectedconmaetipgasto.TIPGAS_NOMBRE) || this.selectedconmaetipgasto.TIPGAS_NOMBRE === '') {
          this.message.add({
            key: 'contipogasto',
            severity: 'error',
            summary: 'Validación de Tipos de Gasto ',
            detail: 'El nombre del tipo de gasto no puede estar vacío'
          });
          return
        }
        if (this.selectedconmaetipgasto.NUEVOL === true) {
          try {
            await this.tipgastoService.guardarTipoGasto(this.selectedconmaetipgasto)
            this.auditoriagral.registrarAuditoria('CON_MAETIPGAS', String(this.selectedconmaetipgasto.TIPGAS_CODIGO) + '/' + String(this.selectedconmaetipgasto.TIPGAS_NOMBRE), 'I',
              '', '01', '', '', '', '').subscribe(() => {
              });
            this.message.add({
              key: 'contipogasto',
              severity: 'success',
              summary: 'Inserción de Tipo de Gasto',
              detail: 'Se ha insertado de Tipo de Gasto'
            });
            await this.manejarSenales('Cancelar')
          } catch (error) {
            this.message.add({
              key: 'contipogasto',
              severity: 'error',
              summary: 'Inserción tipo de gasto',
              detail: 'Ocurrió un error al insertar el tipo de gasto ' + error
            });
          }
        } else if (this.selectedconmaetipgasto.NUEVOL === false) {
          try {
            await this.tipgastoService.actualizarTipoGasto(this.selectedconmaetipgasto)
            this.auditoriagral.registrarAuditoria('CON_MAETIPGAS', String(this.selectedconmaetipgasto.TIPGAS_CODIGO) + '/' + String(this.selectedconmaetipgasto.TIPGAS_NOMBRE), 'A',
              '', '01', '', '', '', '').subscribe(() => {
              });
            this.message.add({
              key: 'contipogasto',
              severity: 'success',
              summary: 'Actualización de Tipo de Gasto',
              detail: 'Se ha actualizado de Tipo de Gasto'
            });
            await this.manejarSenales('Cancelar')
          } catch (error) {
            this.message.add({
              key: 'contipogasto',
              severity: 'error',
              summary: 'Actualización tipo de gasto',
              detail: 'Ocurrió un error al actualizar el tipo de gasto ' + error
            });
          }
        }
      } else if (this.permisoTipGasto.PERACTUALIZACION === 0) {
        this.message.add({
          key: 'contipogasto',
          severity: 'error',
          summary: 'Actualización de Tipos de Gastos ',
          detail: 'El usuario no tiene permisos de actualización, acción denegada'
        });
      }
    }
    if (valor === 'Borrar') {
      if (this.permisoTipGasto.PERELIMACION === 1) {
        //this.btnNuevo = false;
        //this.aggrid.isEditable(false);
        if (this.selectedconmaetipgasto === undefined) {
          this.message.add({
            key: 'contipogasto',
            severity: 'error',
            summary: 'Eliminación de Tipos de Gastos',
            detail: ' Seleccion Incorrecta, no se ha selecionado un tipo de gasto'
          });
        } else {
          this.confirmarTipgas();
        }
      } else if (this.permisoTipGasto.PERELIMACION === 0) {
        this.message.add({
          key: 'contipogasto',
          severity: 'error',
          summary: 'Eliminación de Tipos de Gastos',
          detail: 'El usuario no tiene permisos de Eliminacion, acción denegada'
        });
      }
    }
    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  confirmarTipgas() {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea eliminar el tipo de gasto seleccionado',
      header: 'Eliminar Tipo Gasto',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmtipogasto',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.eliminarTipgas();
      },
      reject: () => {
      }
    });
  }
  async eliminarTipgas() {
    if (this.selectedconmaetipgasto.NUEVOL === false) {


      if (this.selectedconmaetipgasto.TIPGAS_CODIGO === '') {
        this.message.add({
          key: 'contipogasto',
          severity: 'error',
          summary: 'Eliminación de Tipos de Gastos',
          detail: 'No se ha seleccionado un Tipo de Diario a Eliminar'
        });
      } else if (this.selectedconmaetipgasto.TIPGAS_CODIGO !== '') {
        try {
          await this.tipgastoService.eliminarTipoGasto(this.selectedconmaetipgasto)
          this.message.add({
            key: 'contipogasto',
            severity: 'success',
            summary: 'Eliminación de Tipos de Gastos',
            detail: 'Se ha eliminado el Tipo de Gasto'
          });
          this.auditoriagral.registrarAuditoria('CON_MAETIPGAS', String(this.selectedconmaetipgasto.TIPGAS_CODIGO), 'E',
            '', '01', '', '', '', '').subscribe(() => {
            });
          await this.manejarSenales('Cancelar')
          this.btnNuevo = false;
          this.btnGuardar = true;
          this.btnBorrar = false;
          this.btnRegresar = true;
        } catch (error) {
          this.message.add({
            key: 'contipogasto',
            severity: 'error',
            summary: 'Eliminación de Tipo de Diario',
            detail: 'Ocurrió un error al eliminar el tipo de gasto'
          });
        }
      }
    } else if (this.selectedconmaetipgasto.NUEVOL === true) {
      this.conmaetipgasto = this.conmaetipgasto.filter((val, j) => j !==
        this.conmaetipgasto.indexOf(this.selectedconmaetipgasto));
      this.aggrid.refreshaggrid(this.conmaetipgasto, this.defaultColDefconmaetipgasto.objeto);
      this.btnNuevo = false;
      this.btnGuardar = true;
      this.btnBorrar = false;
      this.btnRegresar = true;
    }
  }
  selectConMaeTipo(elemento) {
    if (elemento.object !== null) {
      this.selectedconmaetipgasto = elemento.object;
    }
  }
  cambioModulo(evento) {
    this.btnGuardar = false;
    this.btnRegresar = false;
    this.btnNuevo = true;
  }
}
